import { render, staticRenderFns } from "./PackageCompareTable.vue?vue&type=template&id=24146b1e&scoped=true&"
import script from "./PackageCompareTable.vue?vue&type=script&lang=js&"
export * from "./PackageCompareTable.vue?vue&type=script&lang=js&"
import style0 from "./PackageCompareTable.vue?vue&type=style&index=0&id=24146b1e&lang=scss&scoped=true&"
import style1 from "./PackageCompareTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24146b1e",
  null
  
)

export default component.exports